export class AssetType {
    id: number;
    code: string;
    name: string;
    state: any;
}